module.exports = __webpack_public_path__ + "static/img/6.64401c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/eng/6.png
// module id = YD73
// module chunks = 0